// Technical figures for /measuring-guide, transcribed from the supply-only full
// cassette awning installation manual (asg-full-cassette-awning-installation-manual-v2.pdf,
// "Sizing and clearances"). Kept here rather than inline in the page so the
// numbers have one home and can be checked against the manual in one place.
//
// If the manual is revised, update these and the manual together - the guide
// must never state a clearance the installer's manual contradicts.

// Retracted arm length by arm projection. Both in metres. The AW01's maximum
// extension is 3.5 m, so the table stops there.
export const RETRACTED_ARM_LENGTHS = [
  { projection: '1.0 m', retracted: '0.76 m' },
  { projection: '1.5 m', retracted: '1.04 m' },
  { projection: '2.0 m', retracted: '1.32 m' },
  { projection: '2.5 m', retracted: '1.54 m' },
  { projection: '3.0 m', retracted: '1.85 m' },
  { projection: '3.5 m', retracted: '2.05 m' },
];

export const CLEARANCE_RULES = [
  'At least 8 cm clear at each end of the cassette.',
  'Allow 6.5 cm from the end of the cassette to the outer bracket position.',
  'At least 10 cm clear of any internal or external corner, so the masonry does not crack.',
  'At least 5 cm between the two folding arms without a centre bracket.',
  'At least 10 cm between the arms with a centre bracket fitted. The centre bracket itself is 5 cm wide.',
];

// What each wall type needs by way of anchor. The load sits at the bracket
// points (two, or three from 4 m wide - config/installation.js), so the anchor has to reach the structure - on solid walls that is
// the wall itself; on hollow, rendered or clad walls it is what lies behind.
export const SUBSTRATE_SUITABLE = 'solid load-bearing masonry, concrete, or an engineered structural member';
export const SUBSTRATE_ANCHORS = [
  { wall: 'Concrete, solid brick, structural timber', anchor: 'The supplied anchors, straight in.' },
  { wall: 'Hollow or cavity brick', anchor: 'A chemical anchor with a sieve sleeve, so it engages the structural leaf rather than the void.' },
  { wall: 'Rendered or clad walls', anchor: 'Fix through the surface into the structure behind it. Drill a small pilot hole first to confirm what is there.' },
  { wall: 'Mud brick, or a wall you cannot identify', anchor: 'Get engineering advice before drilling.' },
];

export const OBSTRUCTIONS = [
  'Downpipes',
  'Gutters and gutter brackets',
  'Light fittings and sensors',
  'Meter boxes',
  'Window heads and reveals',
  'Air conditioning units and pipework',
];
